"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkIsStill = void 0;
var minigolfDefs_sidecar_1 = require("../defs/minigolfDefs-sidecar");
var vectorUtils_sidecar_1 = require("../to-engine/vectorUtils-sidecar");
var checkIsStill = function (obj, tolerance) {
    if (tolerance === void 0) { tolerance = 0; }
    // let tolerance = 0.01
    if (!tolerance) {
        tolerance = minigolfDefs_sidecar_1.minigolfDefs.stillnessTolerance;
    }
    if (obj.isDead || obj.isDeactivated) {
        return true;
    }
    var vel = obj.rigidBody.linvel();
    var velMag = vectorUtils_sidecar_1.vectorUtils.magnitude(vel);
    if (velMag > tolerance) {
        return false;
    }
    return true;
};
exports.checkIsStill = checkIsStill;
